<template>
  <v-container fluid>
    <v-card>
      <v-card-title>License key</v-card-title>
      <v-card-subtitle>
        <v-row>
          <v-col class="bold gray" :cols="isMobile ? 6 : 2">License type:</v-col>
          <v-col class="black--text bold" :cols="isMobile ? 6 : 10">{{ licenseType }}</v-col>
        </v-row>
        <v-row>
          <v-col class="bold gray" :cols="isMobile ? 6 : 2">Expired:</v-col>
          <v-col class="black--text" :class="{
            'license-will-be-expired-soon': willExpiredSoon
          }" :cols="isMobile ? 6 : 10">{{ licenseExpiredAt }}</v-col>
        </v-row>
      </v-card-subtitle>
      <v-card-text>
        <v-textarea
          readonly outlined rows="10" placeholder="Your license key will be here"
          v-model="licenseText"
        ></v-textarea>
        <v-alert v-if="!loading && !this.license && profile && !profile.tenant_name" rounded icon="mdi-alert" type="warning">
          You can't get a license without completing the "Office 365 tenant name" field in the "Company Information" section.
        </v-alert>
      </v-card-text>
    </v-card>

    <br/>
    <v-row>
      <v-col :cols="isMobile ? 12 : 2">
        <v-btn
          block
          x-large rounded
          :disabled="!licenseText"
          @click="copy2clipboard"
        >
          Copy
          <v-icon right v-text="copied ? 'mdi-check' : 'mdi-content-copy'"></v-icon>
        </v-btn>
      </v-col>

      <v-col :cols="isMobile ? 12 : 6" />

      <v-col :cols="isMobile ? 12 : 4">
        <v-btn
          block
          color="primary"
          x-large
          rounded
          @click="generate"
          :disabled="disableGenerateBtn"
        >
          Generate license key
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog max-width="350" v-model="successRequestDialog">
      <success-buying-request @close="successRequestDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import SuccessBuyingRequest from "@/components/SuccessBuyingRequest";
import {isMobileMixin} from "@/mixins";
import moment from "moment";

export default {
  name: "LicenseKey",
  mixins: [isMobileMixin],
  components: {SuccessBuyingRequest},
  data() {
    return {
      copied: false,
      successRequestDialog: false,
    }
  },

  computed: {
    ...mapState(['license', 'profile', 'loading', 'request2buy']),
    licenseType() {
      if (!this.license) return  ''
      if (this.license.type === 'TRIAL') return 'Trial'
      if (this.license.type === 'FULL') return 'Purchased'
      return  ''
    },
    licenseText() {
      return this.license ? this.license.key : ''
    },
    licenseExpiredAt() {
      // return this.license.expired
      return this.license ? moment(this.license.expired).format('MM/DD/YYYY hh:mma') : ''
    },
    willExpiredSoon() {
      const expired = this.license ? moment(this.license.expired) : null
      const now = moment()
      return expired && expired.diff(now, 'days') <= 10
    },
    disableGenerateBtn() {
      return this.loading || !!this.license || (this.profile && !this.profile.tenant_name)
    }
  },

  async mounted() {
    await this.getLicense()
  },

  methods: {
    ...mapActions(['getLicense', 'getTrialLicense', 'makeRequest4BuyingLicense']),

    copy2clipboard() {
      try {
        const textArea = document.createElement('textarea')
        textArea.style.visibility = 'none'
        textArea.value = this.licenseText
        document.body.append(textArea)
        textArea.select()
        textArea.setSelectionRange(0, 99999)
        document.execCommand("copy")
        textArea.remove()
        this.copied = true
        clearTimeout(this.copiedTimerId)
        this.copiedTimerId = setTimeout(() => this.copied = false, 2000)
      } catch(e) {
        this.copied = false
        console.log(e.message)
      }
    },

    async requestTrial() {
    },

    async generate() {
      try {
        await this.getTrialLicense()
        await this.makeRequest4BuyingLicense()
        this.successRequestDialog = true
      } catch (e) {
        console.log(e.message)
      }
    }
  }
}
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.gray {
  color: gray;
}

.license-will-be-expired-soon {
  color: red !important;
}
</style>